import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Container, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PageHeader from "../../../reusableComponents/PageHeader";
import { GroupAdd as GroupAddIcon } from "@material-ui/icons";
import isEmpty from "../../../reusableComponents/is-empty";
import { getAllUsers } from "../../../redux/actions/AccountsActions";
import DialogModal from "../../../reusableComponents/Modal/DialogModal";
import Tables from "../../MaterialTable/MaterialTable";
import { getAllAssignmentDocuments } from "../../../redux/actions/assignmentDocumentActions";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(0, 0),
    padding: theme.spacing(0),
  },
}));

const Users = ({
  getAllUsers,
  auth,
  accounts,
  history,
  getAllAssignmentDocuments,
  assignmentDocument,
}) => {
  const [openPopup, setOpenPopup] = useState(false);

  const { isAuthenticated } = auth;
  const { accountUsersList } = accounts;
  const { assignmentDocumentList } = assignmentDocument;
  console.log("assignmentDocumentList", assignmentDocumentList);

  const tableData = assignmentDocumentList.map((item) => ({
    documentId: item?._id,
    firstName: item?.userId?.firstName,
    lastName: item?.userId?.lastName,
    email: item?.userId?.email,
    relatedCourse: item?.courseId?.title,
    relatedScenario: item?.relatedScenarioId?.document?.name,
    fileName: item?.document?.name,
  }));

  useEffect(() => {
    if (isEmpty(accountUsersList) && isAuthenticated) {
      getAllUsers();
    }
  }, [accountUsersList, isAuthenticated]);

  useEffect(() => {
    getAllAssignmentDocuments();
  }, []);

  const columns = [
    {
      title: "First Name",
      field: "firstName",
    },
    {
      title: "Last Name",
      field: "lastName",
    },
    {
      title: "Email ID",
      field: "email",
    },
    {
      title: "Related Course",
      field: "relatedCourse",
    },
    {
      title: "Related Scenario",
      field: "relatedScenario",
    },
    {
      title: "File Name",
      field: "fileName",
    },
  ];

  const options = {
    headerStyle: {
      backgroundColor: "#003399",
      //color: "#3d4977",
      color: "white",
    },
    scrollable: true,
    pageSize: 7,
    searchFieldStyle: {
      width: "100%",
    },
  };
  const classes = useStyles();
  return (
    <>
      <Container maxWidth="lg">
        <Paper className={classes.pageContent}>
          <PageHeader
            title="Users List"
            subTitle="All users list"
            icon={<GroupAddIcon fontSize="large" />}
          />
        </Paper>

        {/* <DialogModal
        title="Create New User"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <AddNew type="user" />
      </DialogModal> */}

        <Tables
          title="Users List"
          columns={columns}
          // data={accountUsersList}
          data={tableData}
          searchField
          //addNewText="Create new User"
          addOnClick={() => setOpenPopup(true)}
          selectedRow={(list) => {
            console.log("selectedRow", list);
            history.push(`/admin/assignmentDocumentViewer/${list?.documentId}`);
          }}
          options={options}
        />
      </Container>
    </>
  );
};

Users.propTypes = {
  getAllUsers: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  accounts: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  accounts: state.accounts,
  assignmentDocument: state.assignmentDocument,
});
const mapDispatchToProps = { getAllUsers, getAllAssignmentDocuments };

export default connect(mapStateToProps, mapDispatchToProps)(Users);
